import { render, staticRenderFns } from "./alert-banner.vue?vue&type=template&id=b8ec41da&scoped=true&"
import script from "./alert-banner.ts?vue&type=script&lang=ts&"
export * from "./alert-banner.ts?vue&type=script&lang=ts&"
import style0 from "./alert-banner.scss?vue&type=style&index=0&id=b8ec41da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ec41da",
  null
  
)

export default component.exports